import { EMPLOYEE_STATUS, PAYMENT_FREQUENCY, SALARY_TYPES } from './constants';
import { COLOMBIA_BANK_ACCOUNT_TYPES } from './dyanamicLocale/countryOptions/colombiaOptions';
import { PERU_BANK_ACCOUNT_TYPES } from './dyanamicLocale/countryOptions/peruOptions';
import { countriesCodes } from '../../i18n/localeHelpers';

export const DEFAULT_EMPLOYEE_OPTIONS = {
  firstName: { value: '', error: '' },
  lastName: { value: '', error: '' },
  payrollId: { value: '', error: '' },
  personalId: { value: '', error: '' },
  email: { value: '', error: '' },
  phone: { value: '', error: '' },
  iban: { value: '', error: '' },
  salary: { value: '', error: '' },
  salaryType: { value: SALARY_TYPES.gross.value, error: '' },
  paymentFrequency: { value: PAYMENT_FREQUENCY.monthly.value, error: '' },
  startDate: { value: '', error: '' },
  status: { value: EMPLOYEE_STATUS.active.value, error: '' },
  contractEnd: { value: '', error: '' },
  subsidiary: { value: '', error: '' },
  collectiveIds: { value: [], error: '' }
};

const getDefaultEmployeeOptionsByLocale = locale => {
  switch (locale) {
    case countriesCodes.colombia:
      return {
        ...DEFAULT_EMPLOYEE_OPTIONS,
        bankAccountType: {
          value: COLOMBIA_BANK_ACCOUNT_TYPES.savings.value,
          error: ''
        },
        bic_swift: { value: '', error: '' },
        address: { value: '', error: '' }
      };
    case countriesCodes.peru:
      return {
        ...DEFAULT_EMPLOYEE_OPTIONS,
        bankAccountType: {
          value: PERU_BANK_ACCOUNT_TYPES.savings.value,
          error: ''
        },
        bic_swift: { value: '', error: '' }
      };
    case countriesCodes.france:
      return {
        ...DEFAULT_EMPLOYEE_OPTIONS,
        salaryType: { value: SALARY_TYPES.net.value, error: '' }
      };
    default:
      return DEFAULT_EMPLOYEE_OPTIONS;
  }
};

export default getDefaultEmployeeOptionsByLocale;
